import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useOutletContext } from "react-router-dom";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Styles from '../../../styles/Plans.module.css'
import { useState } from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { USER_PAYMENTS_FRECUENCY, USER_PAYMENT_PROVIDERS, USER_PLANS } from '../../../utils/structures';
import { getPaymentLink } from '../../../utils/database';
import FreePlanFeatures from '../../../components/FreePlanFeatures';
import ProPlanFeatures from '../../../components/ProPlanFeatures';
import { useNavigate } from 'react-router-dom';

export default function Plans() {
    const outletContext = useOutletContext()

    const [userAuth, userData, userMenu, updateUserData, updateUserMenu, setPreventNavigation] = outletContext ? outletContext : [null, null, null, null, null, null]

    const [frecuency, setFrecuency] = useState(1)
    const [linkIsLoading, setLinkIsLoading] = useState(false)

    const navigate = useNavigate()

    const MONTHLY_PRICE = '5990'
    const ANNUAL_PRICE = '4490'

    const navigateToPayment = async () => {
        setLinkIsLoading(true)
        const link = await getPaymentLink(userData,
            userAuth.uid,
            USER_PAYMENT_PROVIDERS.mercadopago,
            USER_PLANS.pro, frecuency === 1 ? USER_PAYMENTS_FRECUENCY.monthly : USER_PAYMENTS_FRECUENCY.annual)

        setLinkIsLoading(false)
        if (link) {
            window.location.href = link
        }
    }

    return (
        <Stack spacing={2} style={{ maxWidth: '85vw' }}>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={linkIsLoading}
                onClick={() => setLinkIsLoading(false)}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Typography variant='h3' textAlign='center'>Planes para tu negocio</Typography>
            <Typography variant='h6' textAlign='center'>Eligiendo el plan Anual vas a conseguir un 20% OFF, el equivalente a 90 dias gratis</Typography>

            <ToggleButtonGroup
                color="primary"
                value={frecuency}
                exclusive
                onChange={(event, newAlignment) => { if (newAlignment !== null) { setFrecuency(newAlignment) } }}
                className={Styles.toggleButton}
                fullWidth
                sx={{ maxWidth: '300px' }}
            >
                <ToggleButton value={1} fullWidth>Mensual</ToggleButton>
                <ToggleButton value={12} fullWidth>Anual</ToggleButton>
            </ToggleButtonGroup>

            <Stack direction='row' overflow="auto" justifyContent='space-between' spacing={2}>
                <Stack alignItems='center' className={Styles.planContainer} spacing={2}>
                    <Typography variant='h4'>Plan gratuito</Typography>
                    <Typography textAlign='center'>Ideal para negocios chicos</Typography>

                    <Typography fontWeight={500} className={Styles.previousPriceFree}>Gratis</Typography>
                    <Stack direction='row' alignItems='flex-end' spacing={1}>
                        <Typography variant='h4' fontWeight={500}>Gratis</Typography>
                    </Stack>

                    {!userMenu ? <button className={Styles.ctaButton} onClick={() => navigate('/admin/signup')}>Comienza gratis ahora</button> :
                        userMenu.plan.type === USER_PLANS.free ?
                            <Button variant='contained' disabled>Este es tu plan actual</Button> :
                            <Button variant='contained' disabled>Ya posees el plan PRO</Button>}


                    <Divider sx={{ width: '100%' }} />

                    <FreePlanFeatures />

                </Stack>

                <Stack alignItems='center' className={`${Styles.planContainer} ${Styles.proPlanContainer}`} spacing={2}>
                    <Typography variant='h4'>Plan PRO</Typography>
                    <Typography textAlign='center'>La mejor solución para negocios gastronomicos</Typography>

                    {frecuency === 1 ? <Typography fontWeight={500}>${MONTHLY_PRICE}/mes</Typography> :
                        <Stack direction='row'>
                            <Typography fontWeight={500} className={Styles.previousPrice}>${MONTHLY_PRICE}</Typography>
                            <Typography fontWeight={500} className={Styles.discount}>AHORRÁ $18.000</Typography>
                        </Stack>}

                    <Stack direction='row' alignItems='flex-end' spacing={1}>
                        <Typography variant='h6'>AR$</Typography>
                        {frecuency === 1 ?
                            <Typography variant='h4' fontWeight={500}>{MONTHLY_PRICE}</Typography> :
                            <Typography variant='h4' fontWeight={500} color='rgb(240, 0, 0)'>{ANNUAL_PRICE}</Typography>}

                        <Typography variant='h6'>/mes</Typography>
                    </Stack>

                    {frecuency === 1 ? null : <Typography fontWeight={500} className={Styles.freeMonths}>+3 meses gratis</Typography>}

                    {!userMenu ? <button className={Styles.ctaButton} onClick={() => navigate('/admin/signup')}>Potencia tu negocio</button>
                        : userMenu.plan.type === USER_PLANS.free ?
                            <button className={Styles.ctaButton} onClick={() => navigateToPayment()}>Contratar</button> :
                            <Button variant='contained' disabled>Este es tu plan actual</Button>}

                    <Divider sx={{ width: '100%' }} />

                    <ProPlanFeatures />

                </Stack>
            </Stack>
        </Stack>
    )
}